module.exports = __webpack_public_path__ + "img/userLogo14.c26c9bc4.jpg";